import { Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'app/shared/services/common.service';

@Directive({
  selector: '[appTwoDecimalRestrict]'
})
/*
Directive to handle number input field whether to allow decimal or not
if decimal is allowed, only to 2 places after decimal
error handling if the input doesnot match the criteria
*/
export class TwoDecimalRestrictDirective implements OnChanges {
  @Output() showError: EventEmitter<any> = new EventEmitter();
  @Input() minAllowed: any;
  @Input() maxAllowed: any;
  @Input() decimalAllowed: any;
  @Input() inputModel = '';
  @Input() inputIndex: any = null;
  // Allow decimal numbers and negative values
  private regex!: RegExp;
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];

  constructor(
    private el: ElementRef,
    private commonService: CommonService
  ) {    
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.regex = this.decimalAllowed == true ? new RegExp(/^-?[0-9]\d*(\.?\d{0,2})?$/) : new RegExp(/^-?(0|[0-9]\d*)?$/);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1 || (event.key == '-' && position == 0)) {
      return;
    }
    const next: string = [
      current.slice(0, position),
      event.key == 'Decimal' ? '.' : event.key,
      current.slice(position),
    ].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
  
  @HostListener('focusout', ['$event'])
  onFocusOut(event: any) {
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key == 'Decimal' ? '.' : event.key,
      current.slice(position),
    ].join('');   
    const numValue: any = (current != null && current != undefined && current != '') ? Number(current.replace(',', '')) : null;    
    if (next && !String(next).match(this.regex)) {      
      this.showError.emit({isError: true, 
        errorMsg: this.decimalAllowed ? 
          (this.commonService.getTranslatedVal('only_numbers_allowed_error_message') +' '+ this.commonService.getTranslatedVal(this.inputModel) + ' ' + this.commonService.getTranslatedVal('field') + '\n ') : 
          (this.commonService.getTranslatedVal('no_decimal_error_message') +' '+ this.commonService.getTranslatedVal(this.inputModel) + ' ' + this.commonService.getTranslatedVal('field') + '\n ')
        });
    } else if (isNaN(numValue)) {
      this.showError.emit({isError: true, errorMsg: this.commonService.getTranslatedVal('entered_value') +' '+ this.commonService.getTranslatedVal(this.inputModel) +' '+ this.commonService.getTranslatedVal('field') + '\n '});
    } else if ((numValue != undefined && numValue != null) && (this.minAllowed != undefined && this.minAllowed != null) && (numValue < this.minAllowed)) {      
      this.showError.emit({isError:true, errorMsg: this.commonService.getTranslatedVal(this.inputModel) +' '+ this.commonService.getTranslatedVal('should_be_greater') +' '+ this.minAllowed + '\n '});
    } else if ((numValue != undefined && numValue != null) && (this.maxAllowed != undefined && this.maxAllowed != null) && (numValue > this.maxAllowed)) {      
      this.showError.emit({isError: true, errorMsg: this.commonService.getTranslatedVal(this.inputModel) +' '+ this.commonService.getTranslatedVal('should_be_less') +' '+ this.maxAllowed + '\n '});
    } else {      
      this.showError.emit({isError:false, errorMsg: ''});
    }
  }

}
